<template>
    <div class="ts-widget" v-if="data && data.reviews && data.reviews.length >= 1 && dataLoaded">
        <div class="fxc">
            <div class="hl">{{ $attrs.trans4 }}</div>

            <div class="inner">
                <div class="glide-badgex">
                    <vue-glide ref="vueglider" @glide:mount-after="update"
                        :perView="1"
                        :autoplay="10000">
                        <vue-glide-slide v-for="(review, index) in data.reviews" :key="index">
                            <div class="stars">
                                <template v-for="index in review.rating * 1 || 0"><i class="fa fa-star"></i></template>
                                <template v-for="index in 5 - (review.rating * 1 || 0)"><i class="fa fa-star grey"></i></template>
                            </div>
                            <div class="comment" v-html="review.comment && review.comment.trim()"></div>
                            <div class="date">
                                <template v-if="review.name && review.name.trim() != ''">{{ review.name.trim() }},</template>
                                <template v-else>Community-Mitglied,</template>
                                {{ formatDate(review.submittedAt) }}
                            </div>
                        </vue-glide-slide>
                        <template slot="control">
                            <button data-glide-dir="<"><svg width="20" height="20" viewBox="0 0 20 20"><use href="#svg_arrow" /></svg></button>
                            <button data-glide-dir=">"><svg width="20" height="20" viewBox="0 0 20 20"><use href="#svg_arrow" /></svg></button>
                        </template>
                    </vue-glide>
                    <div class="badgex">
                        <div class="l">
                            <div class="rate-stars">
                                <span>{{ data.rating365.toString().replace('.',',') }}</span>
                                <span>
                                    <span class="rate-blank">
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                    </span>
                                    <span class="rate-full" :style="'width:' + data.rating365 * 20 + '%'">
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                        <i class="fa fa-star"></i>
                                    </span>
                                </span>
                            </div>
                            <div>{{ data.count365 }} <span v-html="$attrs.trans5"></span></div>
                            <div>{{ data.overallCount }} {{ $attrs.trans6 }}</div>
                            <div><a href="https://www.trustedshops.de/bewertung/info_X8FBC0170222C357E43FE6B90AEB9A178.html" target="_blank">{{ $attrs.trans7 }} {{ formatDate(data.calculatedAt) }}</a></div>
                        </div>
                        <a href="https://www.trustedshops.de/bewertung/info_X8FBC0170222C357E43FE6B90AEB9A178.html" target="_blank"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0AQMAAADxGE3JAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAADVJREFUeNrtwTEBAAAAwiD7p/ZZDGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOX0AAAEidG8rAAAAAElFTkSuQmCC" data-src="https://cdn03.plentymarkets.com/r82ckxwxroh6/frontend/Redesign/img/ts.webp" alt="" class="lazyload"></a>
                    </div>
                </div>
            </div>
        </div>
        <svg class="hide">
            <g id="svg_arrow"><rect width="20" height="20" rx="10"/><g transform="translate(7.75 6)"><path d="M4.457.707.707,4.457l3.75,3.75" transform="translate(-0.707 -0.707)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/></g></g>
        </svg>
    </div>
</template>

<script>
    import { Glide, GlideSlide } from 'vue-glide-js';

    export default {
        components: {
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },
        data: function() {
            return {
                data: [],
                dataLoaded: false,
            }
        },
        mounted() {
            var self = this;

            $.getJSON('/rest/cytTrustedShops/ratings').done(function(data) {
                self.data = data;
                self.dataLoaded = true;
            });
        },
        methods: {
            formatDate(dateStr) {
                if (!dateStr) return '';
                const [y, m, d] = dateStr.split('T')[0].split('-');
                return `${d}.${m}.${y}`;
            },
            update() {
                var self = this;
                setTimeout(function() {
                    self.$refs.vueglider.glide.update();
                }, 500);
            }
        }
    }
</script>
